var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (leadership) {pug_html = pug_html + "\u003Csection class=\"leadership\"\u003E\u003Cdiv class=\"container text-center\"\u003E\u003Cdiv class=\"sub-title\"\u003ELeadership\u003C\u002Fdiv\u003E\u003Ch2\u003EOur leadership team is comprised of industry leaders and domain experts, bringing decades of cumulative insight and experience to our company and customers.\u003C\u002Fh2\u003E\u003Cdiv class=\"leadership__lead\"\u003E";
// iterate leadership
;(function(){
  var $$obj = leadership;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var lead = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle class=\"leadership__lead__profile\"\u003E\u003Cimg" + (pug.attr("src", lead.avatarUrl, true, true)+pug.attr("alt", lead.name, true, true)) + "\u003E\u003Cdiv class=\"h4\"\u003E" + (pug.escape(null == (pug_interp = lead.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cp class=\"title\"\u003E" + (pug.escape(null == (pug_interp = lead.title) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Farticle\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var lead = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle class=\"leadership__lead__profile\"\u003E\u003Cimg" + (pug.attr("src", lead.avatarUrl, true, true)+pug.attr("alt", lead.name, true, true)) + "\u003E\u003Cdiv class=\"h4\"\u003E" + (pug.escape(null == (pug_interp = lead.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cp class=\"title\"\u003E" + (pug.escape(null == (pug_interp = lead.title) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Farticle\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"leadership" in locals_for_with?locals_for_with.leadership:typeof leadership!=="undefined"?leadership:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/partials/leadership.pug
// module id = 1174
// module chunks = 0